import { render, staticRenderFns } from "./WaiterChangeApplicationMessageConfirmModal.vue?vue&type=template&id=2c8cda57&lang=pug"
import script from "./WaiterChangeApplicationMessageConfirmModal.vue?vue&type=script&lang=ts"
export * from "./WaiterChangeApplicationMessageConfirmModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports